// OKV-262: the scoring model as it was when the efficiency test was calculated, as stored by the
// backend in the result's summary (`drivers[].indicators`, `scoringProfileLastEditedAt`, …). Only the
// snapshot is read — never the model's current version — and anything missing or malformed is
// skipped without throwing: tests calculated before the snapshot existed simply show no indicators.

// The family's indicators ([{ code, weight }], in the snapshot's order); [] when there are none.
// `weight` is the indicator's weight inside its family, null when not a number.
export function getFamilyIndicators(driver) {
  const indicators = driver && Array.isArray(driver.indicators) ? driver.indicators : []
  return indicators
    .filter((el) => el && typeof el.code === 'string' && el.code !== '')
    .map((el) => ({
      code: el.code,
      weight: typeof el.weight === 'number' && !isNaN(el.weight) ? el.weight : null,
    }))
}

// "2026-10-19T08:48:53" → { date: <local Date of that day>, time: '08:48' }, or null. The value is
// read as written (no time zone conversion), the same way the other dates of the test are shown.
export function parseSnapshotDateTime(value) {
  const match = typeof value === 'string' ? value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/) : null
  if (!match) return null
  const [, year, month, day, hours, minutes] = match.map(Number)
  const date = new Date(year, month - 1, day)
  if (date.getMonth() !== month - 1 || date.getDate() !== day || hours > 23 || minutes > 59) return null
  return { date, time: match[4] + ':' + match[5] }
}
